import { Model } from '@models'
import { HealthKit } from '@services'
import { Caching, User } from '@utils'
import { Device } from '@config'

import commonReducers from '@src/models/commonReducers'
import { healthKitSyncStatusSelector } from '@src/selectors/integrations'
import { Scan } from '@src/types'
import { RootStoreState } from '@src/models/app.types'
import ALL_SCANS from '../graphql/allScans'

import { transform } from '../transforms'

const NAMESPACE = 'scans'

const isHealthKitSyncDisabled = function* (_: any, { call, select }: any) {
  const isImpersonating: boolean = yield call(User.isImpersonating)
  const isEnabled: boolean = yield select(healthKitSyncStatusSelector)
  const healthKitSync = Device.hasHealthKit && !isImpersonating && isEnabled

  return !healthKitSync
}

export default class Measurements {
  namespace = NAMESPACE

  state = {
    ...Model.defaultState,
    measurements: [],
  }

  effects = {
    fetch: Model.buildEffect({
      name: `${this.namespace}/fetch`,
      query: ALL_SCANS,
      dataPath: 'allMeasurements',
      caching: (variables) => Caching.shouldUseDateRangeCache(variables?.filter),
      cacheKey: (variables) => Caching.listFilterCacheKey('scans/fetch', variables),
      reducers: [
        {
          name: 'fetchListInfinite',
          dataPath: 'measurements',
          transform,
        },
        {
          name: 'syncHealthKit',
          unless: isHealthKitSyncDisabled,
        },
      ],
    }),
  }

  reducers = {
    ...Model.defaultReducers,
    fetchListInfinite: commonReducers.fetchListInfinite,

    syncHealthKit: this.healthKitReducer,
  }

  // Not a true reducer, just uploads data to HealthKit
  healthKitReducer(state: RootStoreState, { payload }: { payload: Scan }) {
    const { measurements } = payload
    const samples = measurements.filter((x) => x.type === 'Glucose')

    HealthKit.saveGlucoseSamples(samples)

    return state
  }
}
